import { SVGProps } from "react";

const UsersIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="#FFF"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-usuarios"
      className="fill-current"
      {...props}
    >
      <g clipPath="url(#clip0_3312_6765)">
        <path
          d="M17.8002 15.2C17.8002 16.6359 16.6361 17.8 15.2002 17.8C13.7643 17.8 12.6002 16.6359 12.6002 15.2C12.6002 13.764 13.7643 12.6 15.2002 12.6C16.6361 12.6 17.8002 13.764 17.8002 15.2ZM27.4002 15.2C27.4002 16.6359 26.2361 17.8 24.8002 17.8C23.3643 17.8 22.2002 16.6359 22.2002 15.2C22.2002 13.764 23.3643 12.6 24.8002 12.6C26.2361 12.6 27.4002 13.764 27.4002 15.2ZM29.8002 27.4H24.5981C24.5995 27.3335 24.6002 27.2668 24.6002 27.2C24.6002 25.4592 24.1262 23.8274 23.3007 22.4285C23.7735 22.28 24.277 22.2 24.8002 22.2C27.5616 22.2 29.8002 24.4385 29.8002 27.2V27.4ZM15.2002 22.2C17.9616 22.2 20.2002 24.4386 20.2002 27.2V27.4H10.2002V27.2C10.2002 24.4386 12.4388 22.2 15.2002 22.2Z"
          stroke="#FFF"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3312_6765">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UsersIcon;
